import styled from '@emotion/styled'

const ArrowButton = styled.button`
  display: flex;
  width: 3rem;
  height: 3rem;
  justify-content: center;
  align-items: center;
  border: 2px solid ${p => p.variant === 'inverted' && p.theme.colors.white};
  background: ${p =>
    p.variant === 'inverted' ? p.theme.colors.black[0] : p.theme.colors.white};
  cursor: pointer;
  outline: none;

  :before {
    content: '';
    position: relative;
    right: 3px;
    transform: rotate(45deg);
    border: solid ${p => p.variant === 'inverted' && p.theme.colors.white};
    border-width: 3px 3px 0 0;
    height: 0.75rem;
    width: 0.75rem;
  }

  :enabled:hover {
    background: ${p =>
      p.variant === 'inverted'
        ? p.theme.colors.white
        : p.theme.colors.black[0]};
    :before {
      border-color: ${p =>
        p.variant === 'inverted'
          ? p.theme.colors.black[0]
          : p.theme.colors.white};
    }
  }

  :disabled,
  :disabled:before {
    border-color: ${p =>
      p.variant === 'inverted'
        ? 'rgba(255,255,255,0.3)'
        : p.theme.colors.gray[3]};
  }
`

export default ArrowButton
